export default __webpack_public_path__ + "static/media/(12).4965e3a5.jpg";